import {
    IGettersMock,
    ICurrencyGettersMock
} from './index'

export const mockCurrencyGetters = (): ICurrencyGettersMock => ({
    getAllCurrencies: jest.fn(),
    getCurrentCurrency: jest.fn(),
    getPriceLabel: jest.fn()
})

export const mockGetters = (): IGettersMock => ({
    ...mockCurrencyGetters(),
    getPlatformInfo: jest.fn(),
    getTravel: jest.fn(),
    // getModal: jest.fn(),
    getOrder: jest.fn(),

    getLocaleDate: jest.fn()
})
